import { html } from 'lit';
import type { VaAlert } from './va-alert';

export function renderVaAlertTemplate(host: VaAlert) {
  return html`
    <div class="alert ${host.type}">
      <wa-icon
        name=${host.type === 'success'
          ? 'check-circle'
          : host.type === 'error'
            ? 'circle-xmark'
            : host.type === 'warning'
              ? 'triangle-exclamation'
              : 'circle-info'}
      ></wa-icon>
      <slot></slot>
      ${host.dismissable ? html`<button @click=${host.handleDismiss}>&times;</button>` : ''}
    </div>
  `;
}
